import React, { useState, useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "../supabaseClient";
import Sidebar from "../components/Sidebar";
import ContentHeader from "../components/ContentHeader";
import CircuitSettings from "../components/CircuitSettings";
import CircuitBenchmark from "../components/CircuitBenchmark";
import CircuitEditor from "../components/CircuitEditor";
import { sup } from "motion/react-client";

// Constants
const TABS = [
  { name: "Code Editor" },
  { name: "Benchmarks" },
  { name: "Settings" },
];

const CircuitPage = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState(0);
  const [circuitFiles, setCircuitFiles] = useState([]);
  const [circuit, setCircuit] = useState(null);
  const [error, setError] = useState(null);

  // Fetch circuit files on mount
  const fetchCircuitFiles = async () => {
    try {
      const { data: files, error: fetchError } = await supabase
        .from("circuit_files")
        .select("*")
        .eq("circuit_id", id)
        .order("name", { ascending: true });

      if (fetchError) throw fetchError;

      setCircuitFiles(files);
      if (files.length !== 0) {
        console.log("Hey, I'm updating local storage value from ", localStorage.getItem('activeFileIndex'));
        localStorage.setItem('activeFileIndex', 0);
        console.log("to ", localStorage.getItem('activeFileIndex'));
      }
    } catch (err) {
      setError(`Failed to load circuit files: ${err.message}`);
      console.error("Error fetching circuit files:", err);
    }
  };

  const fetchCircuitDetails = async () => {
    try {
      const {data, error: fetchError} = await supabase.from("circuits")
      .select("id, name")
      .eq("id", id);

      if (fetchError) throw fetchError;

      setCircuit(data[0]);
    }catch (err) {
      setError(`Failed to find circuit: ${err.message}`);
    }

  }

  useEffect(() => {
    localStorage.setItem('activeFileIndex', null);
    fetchCircuitFiles();
    fetchCircuitDetails();

    return () => {
      localStorage.removeItem('activeFileIndex');
    };
  }, [id]);

  return (
    <div
      className="columns"
      style={{ height: "100vh" }}
    >
      <Sidebar />
      <div className="column p-6 has-background-light">
        <ContentHeader title={circuit?.name} subtitle={`ID: ${id}`} showBackButton={true}/>

        {/* Error Display */}
        {error && (
          <div className="notification is-danger is-light mt-5" role="alert">
            <button className="delete" onClick={() => { setError(null) }}></button>
            <strong>Error:</strong> {error}
          </div>
        )}

        {/* Tabs */}
        {/* <div className="tabs is-medium mb-0 mt-5">
          <ul>
            {TABS.map((tab, index) => (
              <li
                key={`tab-${index}`}
                className={activeTab === index ? "is-active" : ""}
                onClick={() => setActiveTab(index)}
              >
                <a>{tab.name}</a>
              </li>
            ))}
          </ul>
        </div> */}

        {/* Code Editor Tab */}
        {
          <CircuitEditor
            key={id}
            circuit_id={id}
            circuitFiles={circuitFiles}
            onError={setError}
          />}
        {/* {activeTab === 1 && 
          <CircuitBenchmark 
            circuit_id={id}
            circuitFiles={circuitFiles}
            onError={setError} />}
        {activeTab === 2 && <CircuitSettings />} */}
      </div>
    </div>
  );
};

export default React.memo(CircuitPage);
